import { initI18n } from '@/core/i18n';
import basemap from '@/features/basemap/locales/en.json';
import elevation from '@/features/elevation/locales/en.json';
import forecast from '@/features/forecast/locales/en.json';
import glide from '@/features/glide/locales/en.json';
import search from '@/features/search/locales/en.json';
import stations from '@/features/stations/locales/en.json';
import terrain from '@/features/terrain/locales/en.json';
import trails from '@/features/trails/locales/en.json';
import units from '@/features/units/locales/en.json';
import app from './locales/en.json';

// Each feature owns its strings in <feature>/locales/<lng>.json, registered here as a namespace.
export const resources = {
  en: { app, basemap, elevation, forecast, glide, search, stations, terrain, trails, units },
} as const;

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'app';
    resources: (typeof resources)['en'];
  }
}

export const i18nReady = initI18n(resources, 'app');
